const S = "/images/site";
const U = "/images/uploads";

export const CONTACT = {
  phone: "+91 90716 99822",
  phone2: "+91 91132 99822",
  phoneRaw: "+919071699822",
  whatsapp: "919071699822",
  email: "sohanraju@bengaluruinteriorsbysohan.com",
  address: "#60, 2nd Stage, Nagarbhavi, Bengaluru 560079",
  hours: "Mon – Wed 9–6 · Thu – Fri 9–8 · Sat 9–6 · Sun Closed",
  instagram: "https://www.instagram.com/bengaluru_interiors_by_sohan",
  youtube: "https://youtube.com/@bengaluruinteriorsbysohanraju",
  linkedin: "https://www.linkedin.com/in/sohan-raju-1aa836167",
};

export const IMAGES = {
  hero: `${S}/img_15.jpg`,
  logo: `${U}/logo-light.jpg`,
  logoDark: `${S}/img_00.jpg`,
  founder: `${U}/founder-new.jpg`,
  beforeAfter: `${S}/img_08.jpg`,
  beforeShell: `${U}/kitchen.jpg`,
  videoPoster: `${S}/img_33.jpg`,
  video: "/videos/showreel.mp4",
};

export const STATS = [
  { value: 100, suffix: "+", label: "Happy Families" },
  { value: 500, suffix: "+", label: "Rooms Designed" },
  { value: 5, suffix: "★", label: "Google Rating" },
  { value: 6, suffix: "+", label: "Years Experience" },
];

export const SERVICES = [
  { name: "Modular Kitchen", icon: "ChefHat", img: `${S}/img_17.jpg`, desc: "German hardware, seamless finishes", big: true },
  { name: "Living Room", icon: "Sofa", img: `${S}/img_16.jpg`, desc: "Spaces that gather the family" },
  { name: "Bedroom", icon: "BedDouble", img: `${S}/img_19.jpg`, desc: "Sanctuaries of rest" },
  { name: "Wardrobes", icon: "DoorOpen", img: `${S}/img_23.jpg`, desc: "Floor-to-ceiling elegance" },
  { name: "TV Units", icon: "Tv", img: `${S}/img_06.jpg`, desc: "Statement media walls" },
  { name: "False Ceiling", icon: "Layers", img: `${S}/img_22.jpg`, desc: "Sculpted light & shadow" },
  { name: "Lighting", icon: "Lightbulb", img: `${S}/img_32.jpg`, desc: "Layered, warm, cinematic" },
  { name: "Dining", icon: "UtensilsCrossed", img: `${S}/img_03.jpg`, desc: "Rooms for long dinners" },
  { name: "Pooja Room", icon: "Landmark", img: `${S}/img_02.jpg`, desc: "Sacred corners, crafted" },
  { name: "Villa Interiors", icon: "Building2", img: `${S}/img_15.jpg`, desc: "Full-scale luxury estates" },
  { name: "Commercial Interiors", icon: "Briefcase", img: `${S}/img_01.jpg`, desc: "Offices & retail that impress" },
];

export const PROJECTS = [
  { id: 1, title: "Mrs. Ramya's 2 BHK Residence", cat: "Apartment", loc: "1200 Sq. Ft. · Bengaluru", img: `${S}/img_09.jpg`, h: 600, real: true, slug: "ramya-2bhk" },
  { id: 2, title: "Mr. Anil's Villa", cat: "Villa", loc: "2400 Sq. Ft. · Bengaluru", img: `${S}/img_15.jpg`, h: 620, real: true, slug: "anil-villa" },
  { id: 3, title: "Modern Luxury Apartment", cat: "Apartment", loc: "Bengaluru", img: `${S}/img_29.jpg`, h: 560, real: true, slug: "modern-luxury-apartment" },
  { id: 4, title: "Sage & Graphite Kitchen", cat: "Kitchen", loc: "Ramya Residence", img: `${U}/kitchen.jpg`, h: 520, real: true },
  { id: 5, title: "Diamond-Cove Master Bedroom", cat: "Bedroom", loc: "Anil Villa", img: `${S}/img_19.jpg`, h: 640, real: true },
  { id: 6, title: "Towering Walnut Media Wall", cat: "TV Unit", loc: "Ramya Residence", img: `${S}/img_07.jpg`, h: 480, real: true },
  { id: 7, title: "Halo-Ceiling Guest Suite", cat: "Bedroom", loc: "Anil Villa", img: `${S}/img_22.jpg`, h: 540, real: true },
  { id: 8, title: "White & Oak Chef's Kitchen", cat: "Kitchen", loc: "Anil Villa", img: `${S}/img_17.jpg`, h: 560, real: true },
  { id: 9, title: "Graphite Sliding Wardrobe", cat: "Wardrobe", loc: "Anil Villa", img: `${S}/img_23.jpg`, h: 600, real: true },
  { id: 10, title: "Dressing Wardrobe with Mirror", cat: "Wardrobe", loc: "Bengaluru", img: `${U}/wardrobe-wood.jpg`, h: 620, real: true },
  { id: 11, title: "Pastel Kids' Suite", cat: "Bedroom", loc: "Anil Villa", img: `${S}/img_21.jpg`, h: 520, real: true },
  { id: 12, title: "Island Kitchen with Pendants", cat: "Kitchen", loc: "Modern Luxury Apartment", img: `${S}/img_27.jpg`, h: 540, real: true },
  { id: 13, title: "Emerald Pooja Nook", cat: "Pooja", loc: "Bengaluru", img: `${S}/img_02.jpg`, h: 580, real: true },
  { id: 14, title: "Crockery & Display Wall", cat: "Dining", loc: "Bengaluru", img: `${S}/img_03.jpg`, h: 500, real: true },
  { id: 15, title: "Marble-Panel Villa Living", cat: "Villa", loc: "Anil Villa", img: `${S}/img_16.jpg`, h: 560, real: true },
  { id: 16, title: "Racing-Green Foyer Console", cat: "Apartment", loc: "Modern Luxury Apartment", img: `${S}/img_30.jpg`, h: 520, real: true },
  { id: 17, title: "The Wooden Staircase", cat: "Apartment", loc: "Ramya Residence", img: `${S}/img_05.jpg`, h: 600, real: true },
  { id: 19, title: "Mr. Harsha's Apartment", cat: "Apartment", loc: "1,200 Sq. Ft. · Bengaluru", img: `${U}/harsha-tv.jpg`, h: 620, real: true, slug: "harsha-apartment" },
  { id: 18, title: "Cove-Lit Family Lounge", cat: "Apartment", loc: "Modern Luxury Apartment", img: `${S}/img_32.jpg`, h: 560, real: true },
];

export const PROJECT_CATS = ["All", "Apartment", "Villa", "Kitchen", "Bedroom", "Wardrobe", "TV Unit", "Dining", "Pooja"];

export const WHY_US = [
  { title: "Premium Materials", desc: "Only branded plywood, laminates and stones — nothing anonymous enters your home." },
  { title: "German Hardware", desc: "Hettich, Häfele and Blum fittings, engineered for decades of silent, smooth motion." },
  { title: "Transparent Pricing", desc: "Line-item quotes you can actually read. Every rupee accounted for, upfront." },
  { title: "Photorealistic 3D Design", desc: "Walk through your home before a single wall is touched." },
  { title: "Dedicated Project Manager", desc: "One point of contact, daily photo updates, zero chasing." },
  { title: "On-Time Delivery", desc: "Committed handover dates, tracked milestone by milestone." },
  { title: "Quality Warranty", desc: "Comprehensive warranty on carpentry, hardware and finishes." },
  { title: "No Hidden Charges", desc: "The price we quote is the price you pay. In writing." },
];

export const PROCESS = [
  { step: "Discovery", desc: "We listen — your lifestyle, rituals and dreams for the space." },
  { step: "Concept", desc: "Moodboards and spatial stories tailored to your taste." },
  { step: "3D Visualization", desc: "Photorealistic renders of every room, revised until you love it." },
  { step: "Material Selection", desc: "Curated finishes, fabrics and stones — hand-picked together." },
  { step: "Execution", desc: "Factory-precision production with German machinery." },
  { step: "Installation", desc: "White-glove fit-out by our own master craftsmen." },
  { step: "Final Reveal", desc: "The keys, the lights, the moment it becomes home." },
];

export const TESTIMONIALS = [
  {
    name: "Mrs. Ramya & Family",
    loc: "2 BHK Residence · Bengaluru",
    text: "From the initial design discussions to the final handover, every detail was handled with professionalism and care. The team transformed our 1200 sq. ft. 2 BHK into a modern, elegant, highly functional home — we especially loved the modular kitchen, TV unit and foyer design.",
    rating: 5,
  },
  {
    name: "Mr. Anil",
    loc: "3 BHK Villa · Bengaluru",
    text: "Excellent workmanship and attention to detail. The team delivered exactly what they promised. Our home looks elegant, spacious, and functional. The quality, design, and timely execution were outstanding. Highly recommended!",
    rating: 5,
  },
  {
    name: "Mrs. Vaishnavi",
    loc: "Home Interiors · Bengaluru",
    text: "Every corner of our home reflects thoughtful design and exceptional craftsmanship. The elegant finishes, efficient storage solutions, and premium detailing have exceeded our expectations. We truly appreciate the dedication of the entire team.",
    rating: 5,
  },
];

export const FOUNDER = {
  bio1: "Founded in 2020, Bengaluru Interior Design Company was born from a simple vision — to create timeless, functional and aesthetically refined spaces that truly reflect the lifestyle and aspirations of the people who live in them.",
  bio2: "With a Master's degree in Industrial Design and over six years in the industry, Sohan blends creativity with technical rigour and human-centred design — leading every project from concept and space planning to execution and final styling.",
  motto: "Designing spaces. Creating experiences. Building dreams.",
  achievements: [
    "Master's degree in Industrial Design",
    "6+ years crafting homes & workspaces across Bengaluru",
    "End-to-end turnkey specialist — homes, villas, kitchens, renovations",
  ],
};

export const MATERIALS = [
  { name: "Wood", tag: "Veneer & Solid", desc: "Natural teak, walnut and oak veneers, hand-polished to a satin finish that deepens with age.", brands: "CenturyPly · Greenply · Natural veneers" },
  { name: "Laminate", tag: "1mm Premium", desc: "High-pressure laminates in matte, gloss and textured finishes — durable, scratch-resistant, timeless.", brands: "Merino · Royale Touche · Greenlam" },
  { name: "Acrylic", tag: "High Gloss", desc: "Mirror-like European acrylic panels with anti-scratch coating for kitchens that always look new.", brands: "Rehau · Meraki" },
  { name: "Glass", tag: "Fluted & Tinted", desc: "Fluted, smoked and lacquered glass for shutters and partitions — light, layered, luxurious.", brands: "Saint-Gobain · Modiguard" },
  { name: "Marble", tag: "Natural Stone", desc: "Statuario, Botticino and exotic granites, book-matched and sealed for a lifetime of drama.", brands: "Imported Italian & Indian stone" },
  { name: "Quartz", tag: "Engineered Stone", desc: "Non-porous, stain-proof quartz countertops in marble-look and solid contemporary tones.", brands: "Kalinga Stone · Caesarstone" },
  { name: "PU Finish", tag: "Lacquered", desc: "Seven-coat polyurethane finishes, sprayed in dust-free booths — the finish of luxury automobiles.", brands: "Asian Paints · ICA" },
];

export const STYLES = [
  { name: "Modern", img: `${S}/img_32.jpg` },
  { name: "Japandi", img: `${S}/img_03.jpg` },
  { name: "Minimal", img: `${S}/img_26.jpg` },
  { name: "Classic", img: `${S}/img_05.jpg` },
  { name: "Industrial", img: `${S}/img_33.jpg` },
  { name: "Contemporary", img: `${S}/img_16.jpg` },
  { name: "Luxury", img: `${S}/img_15.jpg` },
  { name: "Mediterranean", img: `${S}/img_01.jpg` },
];

export const FAQS = [
  { q: "How much do interiors cost in Bangalore?", a: "A well-crafted 2BHK typically starts around ₹7–9 lakhs and a 3BHK around ₹11–14 lakhs with premium materials and German hardware. Use our cost calculator above for an instant estimate tailored to your home." },
  { q: "How long does a full home project take?", a: "Most apartments are handed over in 45–60 days from design sign-off. Villas and larger homes take 75–90 days. We commit to dates in writing and track every milestone." },
  { q: "Do you charge for the first consultation?", a: "No — the first consultation and site visit are completely free, including a preliminary design direction and a transparent, line-item quote. Call +91 90716 99822 to book." },
  { q: "Can I see my home before you build it?", a: "Absolutely. Every project includes photorealistic 3D visualizations of every room. We revise the renders until you love what you see — then we build exactly that." },
  { q: "Do you offer a warranty?", a: "Yes — comprehensive warranty coverage on carpentry, hardware and finishes, so your home stays as perfect as handover day." },
  { q: "Do you take up partial work, like just a kitchen?", a: "Yes. Modular kitchens, wardrobes, TV units or single rooms — we bring the same materials, craftsmen and care to projects of every size." },
];

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Projects", href: "#projects" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const CASE_STUDIES = {
  "ramya-2bhk": {
    title: "Mrs. Ramya's 2 BHK Residence",
    tag: "1200 Sq. Ft. Contemporary Home · Bengaluru",
    cover: `${S}/img_09.jpg`,
    facts: ["1200 Sq. Ft.", "2 BHK", "Contemporary", "Full Turnkey"],
    desc: [
      "Designed for a family seeking a balance of elegance and practicality, this 1200 sq. ft. 2 BHK residence showcases a contemporary interior with warm wooden textures, muted pastel finishes, ambient lighting, and space-efficient storage solutions.",
      "Every corner — from the modular kitchen and TV unit to the bedrooms and foyer — has been thoughtfully crafted to maximize functionality while maintaining a refined, timeless aesthetic.",
    ],
    gallery: [`${S}/img_06.jpg`, `${S}/img_07.jpg`, `${U}/kitchen.jpg`, `${S}/img_09.jpg`, `${S}/img_10.jpg`, `${S}/img_11.jpg`, `${S}/img_12.jpg`, `${S}/img_13.jpg`, `${S}/img_14.jpg`, `${S}/img_05.jpg`],
  },
  "anil-villa": {
    title: "Mr. Anil's Villa",
    tag: "2400 Sq. Ft. 3 BHK Villa · Bengaluru",
    cover: `${S}/img_15.jpg`,
    facts: ["2400 Sq. Ft.", "3 BHK Villa", "Modern Luxury", "Full Turnkey"],
    desc: [
      "A thoughtfully designed 2,400 sq.ft. 3 BHK residence that reflects modern luxury through clean lines, elegant materials, and functional planning. Every space balances aesthetics with everyday comfort — custom-designed furniture, premium finishes, ambient lighting, and seamless storage solutions.",
      "From the sophisticated living room with marble-inspired wall panels to the serene master bedroom featuring a designer wardrobe and statement false ceiling, every element was crafted to create a warm, timeless, and luxurious living experience.",
    ],
    gallery: [`${S}/img_15.jpg`, `${S}/img_16.jpg`, `${S}/img_17.jpg`, `${S}/img_18.jpg`, `${S}/img_19.jpg`, `${S}/img_20.jpg`, `${S}/img_21.jpg`, `${S}/img_22.jpg`, `${S}/img_23.jpg`, `${S}/img_24.jpg`],
  },
  "harsha-apartment": {
    title: "Mr. Harsha's Apartment",
    tag: "1,200 Sq. Ft. Residential Apartment · Bengaluru",
    cover: `${U}/harsha-tv.jpg`,
    facts: ["1,200 Sq. Ft.", "Apartment", "Contemporary Minimalist", "Design & Execution"],
    desc: [
      "Contemporary elegance in a warm neutral palette — this 1,200 sq. ft. apartment for Mr. Harsha was designed around a contemporary, minimalist aesthetic, combining clean lines, subtle textures and sophisticated neutrals to create a home that feels calm, spacious and timeless.",
      "Soft beige, warm grey and white tones form the foundation, while wood finishes, black accents and warm lighting add depth and character. The master bedroom pairs a refined grey upholstered bed with a sleek integrated side unit and full-height wardrobes — its fluted feature wall with concealed warm lighting adds a soft, luxurious backdrop while keeping the room minimal.",
      "The modular kitchen is clean and practical: glossy neutral cabinetry, black granite countertops and a subtle marble-look backsplash, with integrated storage keeping everything uncluttered. Bedrooms carry full-height wardrobes in geometric two-tone finishes, and a warm wood-finished display niche with spot lighting creates a welcoming focal point.",
      "The TV unit brings together marble-look surfaces, fluted textures, metallic detailing and warm backlighting — a sophisticated feature wall that completes the design language. Design theme: Contemporary Minimalism · Warm Neutrals · Functional Luxury.",
    ],
    gallery: [`${U}/harsha-foyer.jpg`, `${U}/harsha-tv.jpg`, `${U}/harsha-kitchen.jpg`, `${U}/harsha-bedroom.jpg`, `${U}/harsha-wardrobe.jpg`],
  },
  "modern-luxury-apartment": {
    title: "Modern Luxury Apartment",
    tag: "Contemporary Home · Bengaluru",
    cover: `${S}/img_29.jpg`,
    facts: ["Full Home", "Contemporary", "Quartz Island", "Smart Storage"],
    desc: [
      "A thoughtfully designed contemporary home that blends elegance, functionality, and timeless aesthetics — featuring a luxurious living room with a bespoke TV unit, designer lighting, and a spacious modular kitchen with a quartz island.",
      "Customized bedrooms, ergonomic study spaces, and smart storage solutions run throughout the home. Warm wooden finishes, premium laminates, subtle textures, and ambient lighting create a sophisticated yet comfortable living experience tailored to the client's lifestyle.",
    ],
    gallery: [`${S}/img_25.jpg`, `${S}/img_26.jpg`, `${S}/img_27.jpg`, `${S}/img_28.jpg`, `${S}/img_29.jpg`, `${S}/img_30.jpg`, `${S}/img_31.jpg`, `${S}/img_32.jpg`, `${S}/img_33.jpg`, `${S}/img_34.jpg`, `${S}/img_35.jpg`, `${S}/img_36.jpg`],
  },
};

export const INSTA_FEED = [
  { img: `${S}/img_29.jpg`, href: "https://www.instagram.com/reel/DblLjHCBZrN/" },
  { img: `${S}/img_19.jpg`, href: "https://www.instagram.com/bengaluru_interiors_by_sohan" },
  { img: `${S}/img_36.jpg`, href: "https://www.instagram.com/bengaluru_interiors_by_sohan" },
  { img: `${S}/img_17.jpg`, href: "https://www.instagram.com/bengaluru_interiors_by_sohan" },
  { img: `${S}/img_28.jpg`, href: "https://www.instagram.com/bengaluru_interiors_by_sohan" },
  { img: `${S}/img_22.jpg`, href: "https://www.instagram.com/bengaluru_interiors_by_sohan" },
];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
